import { CONSTS } from '../config/objectConst'

const KEY = 'contactsPageSize'

export const contactsPageSize = {
	get() {
		let result = CONSTS.PAGE_SIZE
		const saved = localStorage.getItem(KEY)

		if (saved) {
			result = Number(saved)
		}

		return result
	},

	save(value: number) {
		localStorage.setItem(KEY, String(value))
	}
}
